import React, { useState } from 'react';
import { Search } from 'lucide-react';
import OrderCard from './OrderCard';
import { statusConfig } from '../../../config/orderStatus';

const OrdersView = ({ orders, onView, onAction, userRole }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');

    const filteredOrders = orders.filter(order => {
        const matchesSearch = order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
            order.customer.name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || order.status === statusFilter;
        return matchesSearch && matchesStatus;
    });

    return (
        <div className="space-y-3 md:space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Orders</h1>
            </div>

            <div className="flex gap-2 md:gap-3">
                <div className="flex-1 relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    <input
                        type="text"
                        placeholder="Search orders..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-1.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                </div>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-white"
                >
                    <option value="all">All Status</option>
                    {Object.keys(statusConfig).map(status => (
                        <option key={status} value={status}>{statusConfig[status].label}</option>
                    ))}
                </select>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
                {filteredOrders.map(order => (
                    <OrderCard
                        key={order.id}
                        order={order}
                        onView={onView}
                        onAction={onAction}
                        userRole={userRole}
                    />
                ))}
            </div>

            {filteredOrders.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                    No orders found matching your criteria
                </div>
            )}
        </div>
    );
};

export default OrdersView;
